import script from "./WelcomeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WelcomeModal.vue?vue&type=script&setup=true&lang=ts"

import "./WelcomeModal.vue?vue&type=style&index=0&id=ba862c30&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba862c30"]])

export default __exports__